(()=>{'use strict';
const $=(s,r=document)=>r.querySelector(s),$$=(s,r=document)=>[...r.querySelectorAll(s)];
const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;

/* Header shadow on scroll */
const header=$('.header');
if(header){const onScroll=()=>header.classList.toggle('is-stuck',scrollY>4);addEventListener('scroll',onScroll,{passive:true});onScroll();}

/* Mobile drawer */
const nav=$('#wardrobe-nav'),menuBtn=$('[data-menu]'),scrim=$('.p-scrim');
function setMenu(open){if(!nav)return;nav.classList.toggle('is-open',open);scrim&&scrim.classList.toggle('is-open',open);menuBtn&&menuBtn.setAttribute('aria-expanded',String(open));document.documentElement.style.overflow=open?'hidden':'';if(open){$('a',nav)?.focus({preventScroll:true})}}
menuBtn&&menuBtn.addEventListener('click',()=>setTimeout(()=>setMenu(nav.classList.contains('is-open')),0));
$$('[data-menu-close]').forEach(b=>b.addEventListener('click',()=>{setMenu(false);menuBtn&&menuBtn.focus()}));
scrim&&scrim.addEventListener('click',()=>setMenu(false));
addEventListener('keydown',e=>{if(e.key==='Escape'&&nav&&nav.classList.contains('is-open'))setMenu(false)});
addEventListener('resize',()=>{if(innerWidth>1100&&nav&&nav.classList.contains('is-open'))setMenu(false)});

/* Cart count mirror (unlike.js writes "(n)" into [data-cart-count]) */
const src=$('[data-cart-count]'),dst=$('[data-p-count]');
if(src&&dst)new MutationObserver(()=>{dst.textContent=(src.textContent||'').replace(/\D/g,'')||'0'}).observe(src,{childList:true,characterData:true,subtree:true});

/* Search */
const dlg=$('#search-dialog');
$$('[data-p-search]').forEach(b=>b.addEventListener('click',()=>{if(dlg&&!dlg.open){dlg.showModal();$('input[type=search]',dlg)?.focus()}}));
$('[data-close]',dlg||document)?.addEventListener('click',()=>dlg.open&&dlg.close());
dlg&&dlg.addEventListener('click',e=>{if(e.target===dlg)dlg.close()});

/* Slideshow */
$$('[data-p-slideshow]').forEach(root=>{
  const slides=$$('.p-slide',root),dots=$$('.p-dots button',root);if(slides.length<2)return;
  let i=0,timer;
  function go(n){slides[i].classList.remove('is-active');dots[i]&&dots[i].setAttribute('aria-current','false');i=(n+slides.length)%slides.length;slides[i].classList.add('is-active');dots[i]&&dots[i].setAttribute('aria-current','true');$$('img[data-src]',slides[i]).forEach(img=>{img.src=img.dataset.src;img.removeAttribute('data-src')});}
  function play(){if(reduced)return;clearInterval(timer);timer=setInterval(()=>go(i+1),6000)}
  dots.forEach((d,n)=>d.addEventListener('click',()=>{go(n);play()}));
  let x0=null;root.addEventListener('touchstart',e=>{x0=e.touches[0].clientX},{passive:true});
  root.addEventListener('touchend',e=>{if(x0===null)return;const dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>45){go(i+(dx<0?1:-1));play()}x0=null});
  root.addEventListener('mouseenter',()=>clearInterval(timer));root.addEventListener('mouseleave',play);
  document.addEventListener('visibilitychange',()=>document.hidden?clearInterval(timer):play());
  play();
});

/* Editorial film */
$$('[data-p-film]').forEach(wrap=>{
  const v=$('video',wrap),btn=$('button',wrap);if(!v)return;let loaded=false,userPaused=false;
  const load=()=>{if(!loaded&&v.dataset.src){v.src=v.dataset.src;loaded=true}};
  const sync=()=>{if(btn)btn.textContent=v.paused?'▶ Play film':'Ⅱ Pause film'};
  v.addEventListener('play',sync);v.addEventListener('pause',sync);
  btn&&btn.addEventListener('click',()=>{load();if(v.paused){userPaused=false;v.play().catch(()=>{})}else{userPaused=true;v.pause()}});
  if(!reduced&&!navigator.connection?.saveData){new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting&&!userPaused){load();v.play().catch(()=>{})}else if(!e.isIntersecting)v.pause()}),{threshold:.35}).observe(v)}
});

/* Reveal on scroll */
const targets=$$('.p-head,.p-col,.p-ov,.p-home-grid .card,.p-iwt__media,.p-iwt__copy');
if(!reduced&&'IntersectionObserver' in window){
  const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}}),{threshold:.08,rootMargin:'0px 0px -30px 0px'});
  const watch=els=>els.forEach((el,n)=>{if(el.classList.contains('p-reveal'))return;el.classList.add('p-reveal');el.style.setProperty('--d',(n%4)*70+'ms');io.observe(el)});
  watch(targets);
}
})();
